/* Bloom theme – vanilla JS, no dependencies */
(function () {
  'use strict';

  var doc = document;
  var win = window;
  var B = win.bloom || { routes: {}, strings: {} };
  var S = B.strings || {};

  function qs(sel, ctx) { return (ctx || doc).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel)); }

  /* ---------- Money ---------- */
  function group(n, dec, thousands, decimal) {
    var fixed = (n / 100).toFixed(dec);
    var parts = fixed.split('.');
    var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    return parts[1] ? whole + decimal + parts[1] : whole;
  }
  function formatMoney(cents) {
    var pattern = B.moneyFormat || '{{amount}}';
    return pattern.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return group(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return group(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return group(cents, 0, '.', ',');
        case 'amount_with_space_separator': return group(cents, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return group(cents, 0, ' ', ',');
        default: return group(cents, 2, ',', '.');
      }
    });
  }

  /* ---------- Toast + cart count ---------- */
  var toastTimer;
  function toast(message, href, linkText) {
    var el = qs('[data-toast]');
    if (!el) return;
    el.textContent = '';
    var span = doc.createElement('span');
    span.textContent = message;
    el.appendChild(span);
    if (href) {
      var a = doc.createElement('a');
      a.href = href;
      a.textContent = linkText;
      el.appendChild(a);
    }
    el.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-on'); }, 4500);
  }
  function setCartCount(n) {
    qsa('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = !n;
    });
  }
  function refreshCart() {
    return fetch(B.routes.cartJs, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { setCartCount(cart.item_count); return cart; });
  }

  /* ---------- Drawer ---------- */
  function setDrawer(open) {
    var d = qs('[data-drawer]');
    if (!d) return;
    d.classList.toggle('is-open', open);
    doc.documentElement.classList.toggle('no-scroll', open);
    qsa('[data-drawer-open]').forEach(function (b) { b.setAttribute('aria-expanded', open ? 'true' : 'false'); });
  }

  /* ---------- Quantity helpers ---------- */
  function syncTiers(root, qty) {
    qsa('[data-tier-qty]', root).forEach(function (t) {
      t.classList.toggle('is-active', Number(t.getAttribute('data-tier-qty')) === qty);
    });
  }

  /* ---------- Global clicks ---------- */
  doc.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;

    if (t.closest('[data-drawer-open]')) { setDrawer(true); return; }
    if (t.closest('[data-drawer-close]')) { setDrawer(false); return; }

    var step = t.closest('[data-qty-step]');
    if (step) {
      var wrap = step.closest('[data-qty]');
      var input = qs('input', wrap);
      if (!input) return;
      var min = input.hasAttribute('min') ? parseInt(input.min, 10) : 1;
      var next = Math.max(min, (parseInt(input.value, 10) || min) + Number(step.getAttribute('data-qty-step')));
      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      if (input.hasAttribute('data-cart-qty') && input.form) {
        if (input.form.requestSubmit) { input.form.requestSubmit(); } else { input.form.submit(); }
      }
      return;
    }

    var tier = t.closest('[data-tier-qty]');
    if (tier) {
      var section = tier.closest('[data-product-section]') || doc;
      var qtyInput = qs('[data-qty-input]', section);
      if (qtyInput) {
        qtyInput.value = tier.getAttribute('data-tier-qty');
        syncTiers(section, Number(qtyInput.value));
      }
    }
  });

  doc.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') setDrawer(false);
  });

  doc.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches && t.matches('[data-qty-input]')) {
      var section = t.closest('[data-product-section]') || doc;
      syncTiers(section, parseInt(t.value, 10) || 1);
    }
    if (t.matches && t.matches('[data-sort]')) {
      var url = new URL(win.location.href);
      url.searchParams.set('sort_by', t.value);
      url.searchParams.delete('page');
      win.location.href = url.toString();
    }
  });

  /* ---------- Add to cart (AJAX) ---------- */
  doc.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('[data-product-form]')) return;
    if (e.submitter && e.submitter.name === 'checkout') return; /* go straight to checkout */
    e.preventDefault();

    var btn = qs('[data-add]', form);
    var err = qs('[data-form-error]', form);
    if (err) err.hidden = true;
    if (btn) { btn.disabled = true; btn.classList.add('is-busy'); }

    var data = new FormData(form);
    data.delete('checkout');

    fetch(B.routes.cartAdd + '.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      body: data
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (!res.ok) { throw new Error(res.json.description || res.json.message || S.error); }
        toast(S.added, B.routes.cart, S.viewCart);
        return refreshCart();
      })
      .catch(function (error) {
        if (err) { err.textContent = error.message || S.error; err.hidden = false; }
      })
      .then(function () {
        if (btn) { btn.disabled = false; btn.classList.remove('is-busy'); }
      });
  });

  /* ---------- Product page ---------- */
  function initProduct(root) {
    var jsonEl = qs('[data-product-json]', root);
    var form = qs('[data-product-form]', root);
    if (!jsonEl || !form) return;
    var product;
    try { product = JSON.parse(jsonEl.textContent); } catch (err) { return; }

    var idInput = qs('[data-variant-id]', form);
    var addBtn = qs('[data-add]', form);
    var nowBtn = qs('[data-now]', form);
    var addLabel = qs('[data-add-label]', form);
    var priceNow = qs('[data-price-now]', root);
    var priceWas = qs('[data-price-was]', root);
    var priceSave = qs('[data-price-save]', root);
    var stickyPrice = qs('[data-sticky-price]', root);
    var track = qs('[data-gal-track]', root);
    var slides = qsa('.gal__slide', root);
    var thumbs = qsa('[data-thumb]', root);

    function selected() {
      var out = [];
      qsa('[data-option]', form).forEach(function (fs) {
        var checked = qs('input[type=radio]:checked', fs);
        out.push(checked ? checked.value : null);
        var label = qs('[data-opt-selected]', fs);
        if (label && checked) label.textContent = checked.value;
      });
      return out;
    }
    function find(opts) {
      if (!opts.length) return product.variants[0];
      return product.variants.filter(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      })[0] || null;
    }
    function goToMedia(id) {
      slides.some(function (s) {
        if (String(s.getAttribute('data-media-id')) === String(id)) {
          s.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
          return true;
        }
        return false;
      });
    }
    function render(v, fromUser) {
      if (!v) {
        if (addBtn) addBtn.disabled = true;
        if (nowBtn) nowBtn.disabled = true;
        if (addLabel) addLabel.textContent = S.unavailable;
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceNow) priceNow.textContent = formatMoney(v.price);
      if (stickyPrice) stickyPrice.textContent = formatMoney(v.price);
      var onSale = v.compare_at_price && v.compare_at_price > v.price;
      if (priceWas) { priceWas.hidden = !onSale; if (onSale) priceWas.textContent = formatMoney(v.compare_at_price); }
      if (priceSave) { priceSave.hidden = !onSale; if (onSale) priceSave.textContent = S.save + ' ' + formatMoney(v.compare_at_price - v.price); }
      if (addBtn) addBtn.disabled = !v.available;
      if (nowBtn) nowBtn.disabled = !v.available;
      if (addLabel) addLabel.textContent = v.available ? S.add : S.soldOut;
      if (fromUser) {
        try { win.history.replaceState(null, '', '?variant=' + v.id); } catch (err) { /* ignore */ }
        if (v.featured_media && v.featured_media.id) goToMedia(v.featured_media.id);
      }
    }

    form.addEventListener('change', function (e) {
      if (e.target.matches('[data-option] input[type=radio]')) { render(find(selected()), true); }
    });

    thumbs.forEach(function (th) {
      th.addEventListener('click', function () {
        var s = slides[Number(th.getAttribute('data-thumb'))];
        if (s) s.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      });
    });
    if ('IntersectionObserver' in win && track && slides.length > 1) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            var i = Number(en.target.getAttribute('data-index'));
            thumbs.forEach(function (th, k) { th.classList.toggle('is-active', k === i); });
          }
        });
      }, { root: track, threshold: 0.6 });
      slides.forEach(function (s) { io.observe(s); });
    }

    /* Sticky mobile order bar */
    var bar = qs('[data-sticky]', root);
    var buy = qs('.pdp__buy', root);
    if (bar && buy && 'IntersectionObserver' in win) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { bar.classList.toggle('is-on', !en.isIntersecting); });
      }).observe(buy);
      var go = qs('[data-sticky-go]', bar);
      if (go) go.addEventListener('click', function () { buy.scrollIntoView({ behavior: 'smooth', block: 'center' }); });
    }

    render(find(selected()), false);
  }
  qsa('[data-product-section]').forEach(initProduct);

  /* ---------- Related products ---------- */
  qsa('[data-related]').forEach(function (el) {
    var url = el.getAttribute('data-url');
    if (!url || !el.hidden) return;
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = doc.createElement('div');
        tmp.innerHTML = html;
        var src = qs('[data-related]', tmp);
        if (src && src.innerHTML.trim().length) {
          el.innerHTML = src.innerHTML;
          el.hidden = false;
        }
      })
      .catch(function () { /* related products are optional */ });
  });

  /* ---------- Header shadow ---------- */
  var header = qs('[data-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', win.scrollY > 6); };
    win.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Reveal on scroll ---------- */
  var reveals = qsa('.reveal');
  var reduce = win.matchMedia && win.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if ('IntersectionObserver' in win && !reduce && reveals.length) {
    var vh = win.innerHeight || 800;
    var later = [];
    reveals.forEach(function (el) {
      if (el.getBoundingClientRect().top < vh) { el.classList.add('in'); } else { later.push(el); }
    });
    doc.documentElement.classList.add('reveal-ready');
    var ro = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('in'); ro.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    later.forEach(function (el) { ro.observe(el); });
  }
})();